<script>
import { mapActions } from 'vuex'
import PosteAimPicker from '@/components/fiche-aim/fiche-aim/ajustement/poste/PosteAimPicker.vue'

export default {
  components: { PosteAimPicker },
  emits: ['created', 'close'],
  props: {
    ficheAimId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      montant: undefined,
      explication: undefined,
      crediteur: undefined,
      debiteur: undefined,
      formValid: undefined,
    }
  },
  computed: {
    isValid() {
      return (
        this.ficheAimId !== undefined && this.crediteur !== undefined && this.debiteur !== undefined && this.formValid
      )
    },
  },
  methods: {
    ...mapActions({
      ajuster: 'ficheAIM/ajusterFicheAIM',
    }),
    clear() {
      this.montant = undefined
      this.explication = undefined
      this.crediteur = undefined
      this.debiteur = undefined
      this.formValid = undefined
    },
    submitAjustement() {
      this.ajuster({
        ficheAIMId: this.ficheAimId,
        explication: this.explication,
        operations: [
          {
            montant: Number(this.montant),
            posteAIMId: this.crediteur.posteAIMId,
          },
          {
            montant: Number(this.montant) * -1,
            posteAIMId: this.debiteur.posteAIMId,
          },
        ],
      }).then((ajustement) => {
        this.clear()
        this.$emit('created', ajustement)
      })
    },
  },
}
</script>

<template>
  <v-form v-model="formValid" @submit.prevent="submitAjustement">
    <v-container class="pa-0">
      <v-row justify="center">
        <v-col cols="3">
          <v-text-field
            v-model="montant"
            dense
            suffix="€"
            clearable
            outlined
            type="number"
            label="Montant à transférer"
            hide-spin-buttons
            :rules="[
              (v) => !!v || 'Vous devez renseigner un montant positif',
              (v) => Number(v) > 0 || 'Le montant doit être positif',
            ]"
          />
        </v-col>
        <v-col cols="9">
          <v-textarea
            class="textarea"
            outlined
            label="Justification"
            no-resize
            rows="2"
            required
            v-model="explication"
            :rules="[(v) => !!v || 'Vous devez renseigner une justification']"
          />
        </v-col>
      </v-row>
      <v-row justify="space-around">
        <v-col cols="5">
          <p>poste à débiter</p>
          <posteAimPicker v-model="debiteur" />
        </v-col>
        <v-col cols="auto" align-self="center">
          <v-icon :color="debiteur !== undefined ? 'primary' : ''" :x-large="debiteur !== undefined">
            {{ debiteur !== undefined ? 'mdi-arrow-right-circle' : 'mdi-arrow-right' }}
          </v-icon>
        </v-col>
        <v-col cols="5">
          <p>poste à créditer</p>
          <posteAimPicker :disabled="debiteur === undefined" v-model="crediteur" :exclude="debiteur" />
        </v-col>
      </v-row>
    </v-container>
    <v-card-actions>
      <v-spacer />
      <v-btn @click="clear">Vider</v-btn>
      <v-btn @click="$emit('close')">Fermer</v-btn>
      <v-btn type="submit" :disabled="!isValid" color="success">
        <v-fab-transition>
          <v-icon v-if="isValid">mdi-plus</v-icon>
        </v-fab-transition>
        Créer
      </v-btn>
    </v-card-actions>
  </v-form>
</template>
